import React from 'react';
import {
    PartyJackpotWelcomePopupDescriptionBox,
    PartyJackpotWelcomePopupTitleBox,
    PartyJackpotWelcomePopupContainerBox,
    PartyJackpotWelcomePopupImageContainerBox,
    PartyJackpotWelcomePopupButtonsContainerBox,
    PartyJackpotWelcomePopupHeaderContainerBox,
    PartyJackpotWelcomePopupBottomNoteBox
} from "./boxes";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {Button} from "../../basic-ui-components/button/base/button.component";
import {Image} from '../raw-components/image/image';
import {IModalDialogHandler} from '../../services/dialog/dialog.service.interface';
import {CyClass} from '../../../common/cy-classes';
import { Link } from '../raw-components/link/link';
import { IBlueRibbonPartyJackpot, PartyJackpotType } from '../../../common/interfaces/blue-ribbon-party-jackpot.interface';
import { PartyJackpotWelcomePopupTitleContainerBox } from './boxes/title-container/party-jackpot-welcome-popup-title-container.box';
import { PartyJackpotWelcomePopupSeparatorBox } from './boxes/separator/party-jackpot-welcome-popup-separator.box';

export interface IPartyJackpotWelcomePopupComponentProps {
    jackpot: IBlueRibbonPartyJackpot;
    dialogHandler: IModalDialogHandler;
    onAcceptButtonClicked: () => void;
    onDeclineButtonClicked: () => void;
}

export class PartyJackpotWelcomePopupComponent extends OrbitComponent<IPartyJackpotWelcomePopupComponentProps> {

    _getTitle() {
        const translationKey = this.props.jackpot.supportsAllLiveGames ? "PARTY_JACKPOT_WELCOME_POPUP_TITLE_ALL_LIVE_CASINO" : "PARTY_JACKPOT_WELCOME_POPUP_TITLE";
        return (
            <PartyJackpotWelcomePopupTitleContainerBox>
                <PartyJackpotWelcomePopupTitleBox hasBothTitleAndSubtitle={this.props.jackpot.supportsAllLiveGames}>
                    { this.services.translation.translate(translationKey, { partyJackpotName: this.props.jackpot.name}) }
                </PartyJackpotWelcomePopupTitleBox>

                { this.props.jackpot.supportsAllLiveGames?
                    <PartyJackpotWelcomePopupTitleBox>
                        { this.services.translation.translate("PARTY_JACKPOT_WELCOME_POPUP_SUB_TITLE_ALL_LIVE_CASINO") }
                    </PartyJackpotWelcomePopupTitleBox>
                    : null
                }
            </PartyJackpotWelcomePopupTitleContainerBox>
        );
    }

    _getDescription() {
        const translationKey = this.props.jackpot.supportsAllLiveGames ?
            "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY_ALL_LIVE_CASINO" :
            this.props.jackpot.hasRealMoneyWinPrize ? 
                this.props.jackpot.type === PartyJackpotType.Daily ? 
                    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL"
                    : "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY"
                : "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION";

        return <PartyJackpotWelcomePopupDescriptionBox>
            <PartyJackpotWelcomePopupSeparatorBox/>
            { this.services.translation.translate(translationKey, {
                partyJackpotName: this.props.jackpot.name,
                startHour: this.props.jackpot.startHour,
                endHour: this.props.jackpot.endHour
            }) }
        </PartyJackpotWelcomePopupDescriptionBox>;
    }

    
    _getBottomNote() {
        return (
            <PartyJackpotWelcomePopupBottomNoteBox>

                { this.services.translation.translate(this.props.jackpot.hasRealMoneyWinPrize? "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE_REAL" : "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE") }
                &nbsp;•&nbsp;
                <Link
                    className={CyClass('cy-party-jackpot-welcome-popup-terms-and-conditions')}
                    onClick={this._onTermsAndConditionsClicked} 
                >
                    { this.services.translation.translate('PARTY_JACKPOT_WELCOME_POPUP_TERMS_AND_CONDITIONS_APPLY') }
                </Link>
            </PartyJackpotWelcomePopupBottomNoteBox>
        );
    }

    _closeDialog() {
        return this.props.dialogHandler.close();
    }

    _onAcceptButtonClicked = () => {
        this.services.partyJackpot.sendAnalytics({
            partyJackpot: this.props.jackpot,
            action: "Opt_In_Welcome_Message",
        });

        this.props.onAcceptButtonClicked();
        this._closeDialog();
    }

    _onDeclineButtonClicked = () => {
        this.services.partyJackpot.sendAnalytics({
            partyJackpot: this.props.jackpot,
            action: "Opt_Out_Welcome_Message",
        });

        this.props.onDeclineButtonClicked();
        this._closeDialog();
    }

    _onTermsAndConditionsClicked = () => {
        this.services.partyJackpot.sendAnalytics({
            partyJackpot: this.props.jackpot,
            action: "TermsAndConditions_Welcome_Message",
        });

        this.services.partyJackpot.openJackpotInfoPage(this.props.jackpot.jackpotId);
        this._closeDialog();
    }

    _getButtons() {
        return <PartyJackpotWelcomePopupButtonsContainerBox>

            <Button
                className={CyClass('cy-party-jackpot-welcome-popup-accept-button')}
                preset="primary"
                fullWidth
                allowLabelWrap
                onClick={this._onAcceptButtonClicked}
            >
                { this.services.translation.translate(this.props.jackpot.supportsAllLiveGames ? 'GOT_IT' : 'LETS_PLAY') }
            </Button>

            { !this.props.jackpot.hasRealMoneyWinPrize ? 
                <Link
                    className={CyClass('cy-party-jackpot-welcome-popup-decline-button')}
                    onClick={this._onDeclineButtonClicked} 
                >
                    { this.services.translation.translate('NO_THANKS') }
                </Link> 
                : null
            }

        </PartyJackpotWelcomePopupButtonsContainerBox>
    }


    render() {
        return (
            <PartyJackpotWelcomePopupContainerBox className={CyClass('cy-party-jackpot-welcome-popup')}>

                <PartyJackpotWelcomePopupHeaderContainerBox>

                    <PartyJackpotWelcomePopupImageContainerBox>
                        <Image src={this.services.theme.currentTheme.images.jackpotWidget.byType.Party.logo.toString()} alt="Party Jackpot" />
                    </PartyJackpotWelcomePopupImageContainerBox>

                    { this._getTitle() }

                </PartyJackpotWelcomePopupHeaderContainerBox>

                { this._getButtons() }
                { this._getDescription() }
                { this._getBottomNote() }

            </PartyJackpotWelcomePopupContainerBox>
        )
    }
}